import { useRef } from "react";
import { Popover, Whisper, WhisperInstance } from "rsuite";
import IconButton from "../../../elements/IconButton";
import DropdownOptionWithIcon from "../../Menus/DropdownOptionWithIcon";

interface Props {
  handleEdit: (() => void) | undefined;
  handleCopy: (() => void) | undefined;
  handleDelete: (() => void) | undefined;
  handleRestore: (() => void) | undefined;
  setMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function CommentOptions({
  handleEdit,
  handleCopy,
  handleDelete,
  handleRestore,
  setMenuOpen,
}: Props) {
  const whisperRef = useRef<WhisperInstance>(null);

  if (!handleCopy && !handleRestore) return null;

  return (
    <Whisper
      placement="bottomEnd"
      trigger={"click"}
      ref={whisperRef}
      speaker={
        <Popover className="sidebar-popover mt-2">
          {handleEdit && (
            <DropdownOptionWithIcon
              icon="mdi mdi-pencil"
              name="Edit Comment"
              onClick={() => {
                handleEdit();
                whisperRef.current?.close();
              }}
            />
          )}
          {handleCopy && (
            <DropdownOptionWithIcon
              icon="mdi mdi-content-copy"
              name="Copy Comment"
              onClick={handleCopy}
            />
          )}
          {handleDelete && (
            <DropdownOptionWithIcon
              icon="mdi mdi-delete"
              name="Delete Comment"
              onClick={() => {
                handleDelete();
                whisperRef.current?.close();
              }}
            />
          )}
          {handleRestore && (
            <DropdownOptionWithIcon
              icon="mdi mdi-restore"
              name="Restore Comment"
              onClick={() => {
                handleRestore();
                whisperRef.current?.close();
              }}
            />
          )}
        </Popover>
      }
      onOpen={() => setMenuOpen(true)}
      onClose={() => setMenuOpen(false)}
    >
      <div>
        <IconButton
          icon="dots-horizontal"
          className="ml-0 mr-0"
          onClick={undefined}
        />
      </div>
    </Whisper>
  );
}
